<template>
	<section class="w-full channelboxes">
		<div class="container mx-auto w-full">
			<Flickity class="flickity-on lg:flickity-off lg:flex lg:space-x-4 xl:space-x-8" :options="options">
				<ChannelBox class="w-5/6 mx-2 max-w-xs sm:w-1/2 lg:w-1/4 lg:mx-auto" :pack-info="flex" />
				<ChannelBox class="w-5/6 mx-2 max-w-xs sm:w-1/2 lg:w-1/4 lg:mx-auto" :pack-info="at120" />
				<ChannelBox class="w-5/6 mx-2 max-w-xs sm:w-1/2 lg:w-1/4 lg:mx-auto" :pack-info="at120plus" />
				<ChannelBox class="w-5/6 mx-2 max-w-xs sm:w-1/2 lg:w-1/4 lg:mx-auto" :pack-info="at200" />
			</Flickity>
		</div>
	</section>
</template>

<script lang="ts">
	import { defineComponent } from 'vue'

	import ChannelBox from '@/components/ChannelBox.vue'
	import Flickity from '@/components/Flickity.vue'
	import { ChannelPack, useChannelPackInfo } from '@/composables/useChannelPackInfo'

	export default defineComponent({
		components: {
			ChannelBox,
			Flickity,
		},

		setup() {
			return {
				flex: useChannelPackInfo(ChannelPack.Flex),
				at120: useChannelPackInfo(ChannelPack.AT120),
				at120plus: useChannelPackInfo(ChannelPack.AT120Plus),
				at200: useChannelPackInfo(ChannelPack.AT200),

				options: {
					groupCells: true,
					pageDots: false,
					watchCSS: true,
				},
			}
		},
	})
</script>

<style scoped>
	.channelboxes::v-deep(.flickity-button) {
		@apply shadow-md bg-gray-100;
	}

	.channelboxes::v-deep(.flickity-prev-next-button) {
		@apply h-8 w-8;
	}
</style>
